<script lang='ts'>

    /* IMPORTS ----------------------------------------------------------------------------------- */

    // CASSIOPEIA
    import {
        Link, Span, Card, Logo, Icon, UserItem, OutputUser, SESSION_API, SESSION_ORGANIZATION,
    } from '@smatch/cassiopeia-web-components';

    // PLUGINS
    import { useNavigate } from 'svelte-navigator';
    const navigate = useNavigate();

    // CONFIG
    import { FAQ_URL } from 'src/config';

    /* INTERNALS ------------------------------------------------------------------------------- */

    const PATH_NAME = window.location.pathname.replace(/\/$/u, '');

    let showFooter = false;

    const toggleVisibility = (): void => {
        showFooter = !showFooter;
    };

    const logout = (): void => {
        navigate('/authentication');
        SESSION_API.clearSession();
    };

</script>

<div class = 's8-wrap'>

    <div class = 's8-top'>

        <h1><Logo /></h1>

        <ul class = 's8-nav'>
            <li class:s8-on = { PATH_NAME.includes('auctions') }>
                <Link url = '/auctions'>
                    <Icon key = 'percent'/> Deals
                </Link>
            </li>
            <li class:s8-on = { PATH_NAME.includes('subscriptions') }>
                <Link url = '/subscriptions'>
                    <Icon key = 'mail'/> Subscriptions
                </Link>
            </li>
        </ul>

        <Icon
            key = { showFooter ? 'chevronDoubleUp' : 'chevronDoubleDown' }
            css = 'h-6'
            on:click = { toggleVisibility }
        />

    </div>

    <footer class:s8-show = { showFooter }>

        {#if $SESSION_ORGANIZATION !== null}
            <Card size = 'md'>
                <UserItem key = { $SESSION_ORGANIZATION.managerKey } let:user>
                    <OutputUser { user } />
                </UserItem>
            </Card>
        {/if}

        <ul>
            <li>
                <Link url = { FAQ_URL }>Help</Link>
            </li>
            <li>
                <Span on:click = { logout }>Logout</Span>
            </li>
        </ul>

    </footer>

</div>

<style lang='postcss'>

    div.s8-wrap {
        display: flex;
        flex-direction: column;

        div.s8-top {
            display: flex;

            h1 {
                outline: none;
            }

            ul.s8-nav {
                display: flex;

                li {
                    border-radius: 8px;

                    &.s8-on {
                        background-color: rgba(255,255,255,1);
                        box-shadow: 0 1px 1px 0px rgba(39,39,17,0.08);

                        :global(a) {
                            color: rgba(39,39,17,1);
                            cursor: default;
                        }

                        :global(svg) {
                            stroke: rgba(39,39,17,1);
                        }
                    }

                    :global(a) {
                        padding: 10px;
                        display: block;
                        color: rgba(39,39,17,0.32);
                        cursor: pointer;
                    }

                    :global(svg) {
                        height: 15px;
                        display: inline-block;
                        margin-top: -2px;
                        margin-right: 4px;
                        stroke: rgba(39,39,17,0.32);
                    }
                }
            }
        }

        footer {
            ul {
                display: flex;
                font-size: 10px;
                color: rgba(39,39,17,0.32);

                li {
                    cursor: pointer;
                }
            }
        }
    }

    /* MOBILE / TABLET VIEW --------------------------------------------------------------- */

    @media (max-width: 1000px) {
        div.s8-wrap {
            box-shadow: 0 1px 1px 0px rgba(39,39,17,0.04);
            background-color: #F4F4F3;
            border-bottom: 1px solid rgba(39,39,17,0.08);

            div.s8-top {
                padding: 10px;
                column-gap: 5px;
                align-items: center;

                h1 {

                    :global(a) {
                        background-color: #ffffff;
                        border-radius: 14px;
                        width: 28px;
                        height: 28px;
                        box-shadow: 0 1px 1px 0px rgba(39,39,17,0.08);
                    }

                    :global(svg) {
                        margin-left: auto;
                        margin-right: auto;
                        height: 15px;
                    }

                    :global(span) {
                        display: none;
                    }
                }

                ul.s8-nav {
                    margin-left: auto;

                    li {
                        height: fit-content;

                        :global(a) {
                            padding: 5px 10px;
                        }
                    }
                }

                :global(> svg) {
                    cursor: pointer;
                }
            }

            footer {
                display: none;
                margin: 10px;
                margin-top: 0px;
                padding-top: 10px;
                border-top: 1px solid rgba(39,39,17,0.04);

                &.s8-show {
                    display: block;
                }

                :global(div.s8-card) {
                    margin-bottom: 5px;
                }

                ul {
                    column-gap: 5px;
                }
            }
        }
    }

    /* DESKTOP VIEW --------------------------------------------------------------- */

    @media (min-width: 1000px) {
        div.s8-wrap {
            padding: 20px 20px 20px 30px;
            height: 100%;
            row-gap: 30px;

            div.s8-top {
                row-gap: 25px;
                flex-direction: column;
                flex-grow: 1;

                h1 {
                    margin-top: 5px;
                }

                ul.s8-nav {
                    flex-direction: column;
                    row-gap: 5px;
                }

                :global(> svg) {
                    display: none;
                }
            }

            footer {
                ul {
                    justify-content: space-between;
                }
            }
        }
    }

</style>